<template>
  <div>
    <component :is="currentStepComponent" @change-step="handleStepChanging" />
  </div>
</template>

<script>
  import InfoRegister from '@/containers/auth/registration-compliting/InfoRegister';
  import ChooseCompany from '@/containers/auth/registration-compliting/ChooseCompany';
  import CompanyDetailsRegister from '@/containers/auth/register/CompanyDetailsRegister';

  export default {
    name: 'Complete',
    model: {
      prop: 'currentStep',
      event: 'next-step',
    },
    props: {
      currentStep: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        completeSteps: {
          1: InfoRegister,
          2: ChooseCompany,
          2.1: CompanyDetailsRegister,
        },
      };
    },
    computed: {
      currentStepComponent() {
        return this.completeSteps[this.currentStep];
      },
    },
    methods: {
      handleStepChanging(step) {
        this.$emit('next-step', step);
      },
    },
  };
</script>
